import * as React from 'react';
import { BackgroundColorContext } from './context';
import { BackgroundColorConfig } from './types';
import { config } from '@shopee-user/business-customization-logic';

export function useBackgroundColor({
  mobile = config.Background.ColorMobile,
  desktop = config.Background.ColorDesktop,
  enableBackgroundColor = true,
}: Partial<BackgroundColorConfig> & {
  enableBackgroundColor?: boolean;
}) {
  const { setBackgroundColorConfig } = React.useContext(BackgroundColorContext);

  React.useLayoutEffect(() => {
    if (enableBackgroundColor) {
      setBackgroundColorConfig({
        mobile,
        desktop,
      });
    }
  }, [setBackgroundColorConfig, mobile, desktop, enableBackgroundColor]);
}
